import { TelephoneContextValue } from "@/modules/lead-page/new/context/telephone.context";
import { createContext, useContext } from "react";

export const TelephoneContext = createContext<TelephoneContextValue | null>(
  null
);

export function useTelephoneContext() {
  const ctx = useContext(TelephoneContext);
  if (!ctx) {
    throw new Error(
      "useTelephoneContext must be used within an TelephoneProvider"
    );
  }
  return ctx;
}
